import { Tr, Td, Skeleton, BoxProps } from "@chakra-ui/react";

export function SkeletonRow({ columns, ...rest }: { columns: number }) {
  return (
    <Tr>
      <Td colSpan={columns} pr="30px" py="2">
        <Skeleton height="40px" {...rest} />
      </Td>
    </Tr>
  );
}

interface SkeletonRowsProps {
  columns: number;
  rows: number;
  boxProps?: BoxProps;
  speed: number;
}

export function SkeletonRows({ columns, rows, boxProps = {}, ...rest }: SkeletonRowsProps) {
  return (
    <>
      {Array.from({ length: rows }).map(() => (
        <SkeletonRow key={crypto.randomUUID()} columns={columns} {...boxProps} {...rest} />
      ))}
    </>
  );
}
